// @flow
import React from 'react'
import {Field} from 'redux-form'
import FieldForm from '../FieldForm'
import FieldLabel from "../FieldLabel";

class BlankField extends React.Component {
    render() {
        const {field, input, ...otherProps} = this.props;
        return React.createElement(field, {...input, ...otherProps});
    }
}

class BlankCheckboxField extends React.Component {
    render() {
        const {title, field, label, checkboxLabel, input, ...otherProps} = this.props;
        const useLabel = label || checkboxLabel;

        let labelComponent;
        if (useLabel) {
            labelComponent = <FieldLabel label={useLabel} title={title} component="span" />
        }

        return React.createElement(field, {
            ...input,
            title,
            ...otherProps,
            label: labelComponent
        });
    }
}

/**
 * Defaultní obal Field (redux-form) pro render s obalem FormField
 *
 * pokud je field = false vyrederuje se pouze daný input
 */
class Base extends React.Component {

    static PropTypes = {
        // componentClass: React.PropTypes.element.isRequired,
        // field: React.PropTypes.element
    };

    static defaultProps = {
        field: FieldForm,
    };

    render() {
        const {componentClass, field, ...otherProps} = this.props;
        let fieldComponent;
        let fieldProps = otherProps;
        if (field === false) {
            if (this.props.check) {
                fieldComponent = BlankCheckboxField;
            } else {
                fieldComponent = BlankField;
            }
        } else {
            fieldComponent = field;
        }
        return <Field component={fieldComponent} field={componentClass} {...fieldProps} />
    }
}



export default Base;
